import { combineReducers } from "redux";

import {
  CLEARING_SALE_PRE_SALE_CSV,
  EXTERNAL_AGENT_XML,
  PRE_SALE_CSV,
  SET_ACTIVE_ROLE,
  SET_CURRENT_LIVESTOCKSALE,
} from "constants/actionTypes";
import { IMPORTER_TYPES } from "constants/importer";

const defaultExternalAgentXmlState = {
  file: null,
  isImporting: false,
  isDataLossAcknowledged: false,
  selectedTab: 0,
  // storing values for a faster import process
  storedMapping: {},
};

// When adding a new importer, just add the name and type to this array
const importerTypes = [
  { name: IMPORTER_TYPES.PRE_SALE_CSV, type: PRE_SALE_CSV },
  { name: IMPORTER_TYPES.EXTERNAL_AGENT_XML, type: EXTERNAL_AGENT_XML },
  {
    name: IMPORTER_TYPES.CLEARING_SALE_PRE_SALE_CSV,
    type: CLEARING_SALE_PRE_SALE_CSV,
  },
];

const createImporterReducers = () => {
  const obj = {};
  importerTypes.forEach(typeObject => {
    const { name, type } = typeObject;
    obj[name] = (state = defaultExternalAgentXmlState, action) => {
      switch (action.type) {
        case type.UPDATE.ACTION: {
          const storedProducts = state.storedMapping?.products || {};
          const storedVendors = state.storedMapping?.vendors || {};
          // collect vendor and product information set in the import action.
          // This is used to store import mappings to be used so that the import process can be faster.
          const newProductsByDescriptionLookup =
            action.payload?.products?.reduce((acc, product) => {
              if (product.productId && product.description) {
                acc[product.description.toLowerCase()] = product;
              }
              return acc;
            }, {}) || {};

          const newVendorsByVendorNameLookup =
            action.payload?.vendors?.reduce((acc, vendor) => {
              if (vendor.vendorId && vendor.vendorName) {
                acc[vendor.vendorName.toLowerCase()] = vendor;
              }
              return acc;
            }, {}) || {};

          return {
            ...state,
            ...action.payload,
            storedMapping: {
              vendors: {
                ...storedVendors,
                ...newVendorsByVendorNameLookup,
              },
              products: {
                ...storedProducts,
                ...newProductsByDescriptionLookup,
              },
            },
          };
        }
        case type.PROCESS.FAILURE:
          return {
            ...defaultExternalAgentXmlState,
            isDataLossAcknowledged: state.isDataLossAcknowledged,
            selectedTab: state.selectedTab,
            storedMapping: state.storedMapping,
          };
        case type.IMPORT.ACTION:
          return {
            ...state,
            isImportRunning: true,
          };
        case type.IMPORT.FAILURE:
          return {
            ...state,
            isImportRunning: false,
          };
        case SET_ACTIVE_ROLE.REQUEST:
        case SET_CURRENT_LIVESTOCKSALE.SUCCESS:
        case type.IMPORT.SUCCESS:
          return {
            ...defaultExternalAgentXmlState,
            storedMapping: state.storedMapping,
          };
        default:
          return state;
      }
    };
  });
  return obj;
};

export default combineReducers(createImporterReducers());
